<template>
    <div>
        <div class="anime_Connent">
            <span class="icon_baseBox status_noNetwork">
                <img class="img-responsive" src="@/assets/images/error_page/computer_noNetwork.svg" alt="">
            </span>
            <div class="status_dongleImgBox">
                <img class="img-responsive" src="@/assets/images/error_page/dongle_connectFailed.svg" alt="">
            </div>
            <span class="icon-bike_connect"></span>
        </div>
        <div class="noticefaild">
            <h4 class="title_hasRedIcon">
                <img src="@/assets/images/error_page/title_wrong.svg" alt="">
               {{getConnFail}} {{$t('connectFailed.failedMsg.unexpectError.p1')}}
            </h4>
            <p class="red">{{$t('connectFailed.failedMsg.unexpectError.p2')}} </p>
            <p class="red">{{$t('connectFailed.failedMsg.unexpectError.p3')}} </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data () {
    return {};
  },
  computed: {
    ...mapGetters({
      getConnFail: 'bikeConnect/getConnFail'
    })
  }
};
</script>
